import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { IActivity } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';

@Component({
  selector: 'app-add-speaker',
  templateUrl: './add-speaker.component.html',
  styleUrls: ['./add-speaker.component.scss']
})
export class AddSpeakerComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Create new speaker"
  form: FormGroup;
  name: AbstractControl;
  isMale: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddSpeakerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }

  ngOnInit() {
    const { SPEAKER } = this.data;
    this.form = this.fb.group({
      name: [SPEAKER ? SPEAKER.name : null, Validators.compose([Validators.required])],
      isMale: [SPEAKER ? SPEAKER.isMale : false, Validators.required]
    })
    if (SPEAKER) {
      this.TITLE = "Edit speaker";
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { FORM, SKILL, ACTIVITY_TYPE, MODULE_KEY, ITEM,ACTIVITY_TYPE_OBJECT,SKILL_NAME } = this.data;
      const { name, instruction, defaultInstruction, youtubeId, languageNotes,reading } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const { speakers } = ITEM;
      const speakerData = { isMale: f.isMale, name: `${f.name}`.trim(), key: this.ds.createId() };
      const SPEAKER_DATA = pushObjArray(speakers, speakerData)
      const registerStatus = STATUS_OBJECT.submitted;

      const activity: IActivity = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name || null,
        reading:reading || null,
        instruction: instruction || null,
        youtubeId: youtubeId || null,
        defaultInstruction: defaultInstruction || false,
        speakers: SPEAKER_DATA,
        languageNotes: languageNotes || null,
        pictureDownloadURL: ITEM ? ITEM.pictureDownloadURL || null : null,
        conversations: ITEM ? ITEM.conversations || [] : [],
        hasSubActivity:false,
        //modules
        skillKey: SKILL,
        skillRef: this.ds.skillRef().doc(SKILL).ref,
        skillName:SKILL_NAME,
        activityTypeKey: ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
        activityTypeName:ACTIVITY_TYPE_OBJECT.name,
        moduleKey: MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
      }
      this.store.addItem(activity,this.data.MODULE, true, (success, res) => {
        this.data.ITEM = activity;
        this.snackBar.open("Speaker has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.dialogRef.close('no')
          return;
        }
        this.form.reset();
        this.form.enable();
        this.form.patchValue({ isFill: false })
        this.processNew = false;
        this.processClose = false;
        this.isCreate = false;
        this.inputEl.nativeElement.focus()
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}